import { CreateSSOProvider, SSOContext } from '@ordr-as/authentication-library'
import { useContext } from 'react'
import config from '../config'

const { provider } = CreateSSOProvider({
    callback_url: window.location.origin,
    environment: config.env === 'prod' ? 'prod' : 'qa',
    app_name: 'payment',
})
const useAuth = () => {
    const authContext = useContext(SSOContext)
    if (!authContext) {
        throw new Error('useAuth must be used within a SSOProvider')
    }
    return authContext
}

const useUser = () => {
    const { decodedAccessToken } = useAuth()

    if (!decodedAccessToken) {
        return undefined
    }

    return {
        email: decodedAccessToken.sub,
    }
}

export { provider as AuthContextProvider, useAuth, useUser }
